import React from "react"

import {
    FormGroup,
    Label,
    Input,
    Col,
} from "reactstrap"

const CheckBox = ({ name, defaultChecked = true, disabled = false, isCenter = false, onChange ,id }) => {

    return (
        <FormGroup check disabled={disabled} className={`${isCenter ? "" : "pull-left"} mr-2 ml-2`}>
            <Label check>
                <Input
                    name={name}
                    id = {id}
                    type="checkbox"
                    disabled={disabled}
                    defaultChecked={defaultChecked}
                    onChange={(e) => onChange(e.currentTarget.checked,e.currentTarget.id)}
                /> {name}
                <span className="form-check-sign" />
            </Label>
        </FormGroup>
    )
}

export default CheckBox